import { render, staticRenderFns } from "./configComponent.vue?vue&type=template&id=50e001f3&scoped=true&"
import script from "./configComponent.vue?vue&type=script&lang=js&"
export * from "./configComponent.vue?vue&type=script&lang=js&"
import style0 from "./configComponent.vue?vue&type=style&index=0&id=50e001f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e001f3",
  null
  
)

export default component.exports